import React  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paynowbutton from '../payments/paynowbutton'
import Paynowgatewaybutton from '../payments/paynowgatewaybutton'
import Container from "@material-ui/core/Container";
import Avatar from "../../../node_modules/@material-ui/core/Avatar";
import CssBaseline from "../../../node_modules/@material-ui/core/CssBaseline";
import Typography from "../../../node_modules/@material-ui/core/Typography";
import { createMuiTheme } from "@material-ui/core/styles"

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useDispatch } from 'react-redux'
import { styled } from '@material-ui/core/styles';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { useEffect } from 'react';
import {paymentSuccess} from '../../actions/paymentActions';
import {paycallback} from '../../actions/authActions';
import {logout} from '../../actions/authActions';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import styles from './OApp.module.css';
import { useHistory } from "react-router-dom";
import {  toast } from 'react-toastify';
import QRCode from 'qrcode.react';
import jwt from 'jsonwebtoken'
import { trackPromise } from 'react-promise-tracker'
import axios from 'axios';
import myImage from './paynow-logo-2.png'; // Replace with your PNG path
import myImage2 from './card.jpg'; // Replace with your PNG path

const apiUrl = 'https://pdmsonlinebanfooksoutheast.azurewebsites.net/online-pdms-trustcare/public/api'
const auth = jwt.decode(localStorage.jwtToken)
const apiUrl_backup = 'https://pdmsonlinebanfooksoutheast.azurewebsites.net/online-pdms-trustcare/public/api'

const paynowfee = 1.00
const creditcardfee = 10.00



const ImageButton = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 16px',
});

const BrownButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#C54800FF', // SaddleBrown
  color: '#fff',
  width : '150px',
  padding: '10px 20px',
  '&:hover': {
    backgroundColor: '#746E6BFF',
  },
}));


const BlueButton = styled(Button)(({ theme }) => ({
  backgroundColor: ' #3f50b5', // SaddleBro
  width : '160px',
  color: '#fff',
  padding: '10px 20px',
  
}));

const RedButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#B9251AFF', // SaddleBro
  width : '160px',
  color: '#fff',
  padding: '10px 20px',
  '&:hover': {
    backgroundColor: '#B9251AFF',
  },
}));

var encryptedStr = "";


function wait(ms){
  var start = new Date().getTime();
  var end = start;
  while(end < start + ms) {
    end = new Date().getTime();
 }
}


const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow:'hidden',
    minWidth: '420px',
    
    width: '15%'
  },
  table: {
    minWidth: 800,
  },
  box: {
    height: 100,
    display: "flex",
    border: "1px solid black",
    padding: 8
  },
  spreadBox: {
    justifyContent: 'space-between',
    alignItems: "center"
  }
}));





  



function SimpleDialog(props) {


  const dispatch = useDispatch()
  const [dopenmy, setDopenmy] = React.useState(false);
  const [dopen_refmy, setDopen_refmy]= React.useState(true);
  const history = useHistory();
   
  var QRstring
  const paymentHandler = (details, data) => {
 
    /** Here you can call your backend API endpoint and update the database    */
    localStorage.setItem('paydone', JSON.stringify(props.data));
    encryptedStr = localStorage.getItem('data.orderIDInLocalStorage')
    
    QRstring = sessionStorage.getItem('mydataqr')

    sessionStorage.setItem('finalmsg',"YES")
    var gateway_fee=sessionStorage.getItem('admin_price')  
    var subtotal_price=sessionStorage.getItem('QR_price')  
    var total_price=sessionStorage.getItem('QR_price')  
    var username=sessionStorage.getItem('username')  

    var res
        var mycount
        var data = props.data
        var order_id= "Paynow :"+props.data.orderID
        var i

      
            dispatch(paymentSuccess(props.data, "Paynow :"+encryptedStr ))
           
        
 
          
 
   
  var amount_s1 = sessionStorage.getItem('QR_price')
   confirmAlert({
    customUI: ({ onClose }) => {
    return (
      <div className="payment-success-container">
      <h1><div className="success-icon">✅</div></h1>
      <h1>Payment Processing ...</h1>
      <h1>Waiting for Hitpay ...</h1>
      <h1>SGD ${total_price}</h1>
      
      <p></p>
      <h1>{shopname}</h1>
      <p></p>
      
      <p></p>
      <p></p>
      
    </div>
    );
    }, closeOnEscape: true,  //**only press on ESC on keyboard to close**
    closeOnClickOutside: false  //**prevent click over white space to close the alert messag**e

    });   

   let propsdata = localStorage.getItem('propsdataInLocalStorage')
   let selected = localStorage.getItem('selectedInLocalStorage')
   var temp = localStorage.getItem('example');
   var viewName = JSON.parse(temp); 
   encryptedStr = localStorage.getItem('data.orderIDInLocalStorage')
    
  
      
         var temp = sessionStorage.getItem('mydata');
         var viewName = JSON.parse(temp); 
         var orderid = sessionStorage.getItem('data.orderIDInLocalStorage')  
         viewName.orderID = sessionStorage.getItem('data.orderIDInLocalStorage')  
     
       
   
   
   }
   

 
  const { onClose, selectedValue, open } = props;
  const handleClose = () => {

  //  localStorage.setItem('paydone', JSON.stringify(props.data));
    window.location.reload();
    
  
   };



  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1.5),
    },
  }))(MuiDialogActions);


  var total_price = 0
  for (let i = 0; i < props.data.length ; i++) {

    let data = props.data[i];

    total_price = total_price + parseInt(data.interest_payable)

  }

  total_price = sessionStorage.getItem('QR_price')  ;
  var shopname = sessionStorage.getItem('shop')  
  var isactive,myuen
  
  if (shopname === 'Trustcare Shop A'  )
  {
  isactive = true
  myuen =  '200807416W'
  
  }
  if (shopname === 'Sheng Cheong Pawnshop'  )
  {
    isactive = true
    myuen =  '199700262R'
  }
  if (shopname === 'Trustcare'  )
  {
    isactive = true
    myuen =  '200807416W'
  }
  if (shopname === 'Sembawang Teck Hing'  )
  {
    isactive = true
    myuen =  '198203780W'
  }
 

   

  return (
    <Dialog  aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="Payment"></DialogTitle>
   
      <Container component="main" maxWidth="xs">

      <Paynowbutton  data={props.data} total={total_price} orderID={total_price} />
  
     
 
        
      <DialogActions>

      <Box component="span"    m={1}
>
<Box display="flex" justifyContent="center" gap={1}>

      <BlueButton   variant="contained"
        sx={{ flex: 1 }} autoFocus onClick={paymentHandler} color="primary"  size="small" style={{ borderRadius: 20, padding: '40px 20px 40px 20px', textAlign: 'center', height: 40 , width: 150 , margin: '8px 30px'}}>
             Accept 
          </BlueButton>
      
          <RedButton   variant="contained"
        sx={{ flex: 1 }} autoFocus onClick={handleClose} color="secondary"  size="small" style={{ borderRadius: 20 , padding: '40px 20px 40px 20px' , textAlign: 'center',height: 40 ,width: 150 , margin: ''}}>
            Cancel
          </RedButton>
    
          </Box>


          </Box>

        </DialogActions>

        </Container>
    </Dialog>

    
  );
}


SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};




function SimpleDialog_M(props) {
  
  
  
  


  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };


  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1.5),
    },
  }))(MuiDialogActions);

  const style = {
    layout: "horizontal", // horizontal | vertical
    size: "responsive", // medium | large | responsive
    shape: "rect", // pill | rect
    color: "gold" // gold | blue | silver | white | black
  };

  var total_price = 0
  for (let i = 0; i < props.data.length ; i++) {

    let data = props.data[i];

    total_price = total_price + parseInt(data.interest_payable)

  }

  return (
    <Dialog  aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="Payment"></DialogTitle>
   
      <Container component="main" maxWidth="xs">
   
     
      <Paynowgatewaybutton  data={props.data} total={total_price} orderID={total_price} />
  
     
 
   
      </Container>

      <DialogActions>
    
          <Button autoFocus onClick={handleClose} color="secondary" variant="contained" size="small">
            Cancel
          </Button>
        </DialogActions>

    </Dialog>
  );
}


SimpleDialog_M.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};


export default function SelectListModal(props) {
  

  const classes = useStyles();
  const [dopen, setDopen] = React.useState(false);
  const [dopen_m, setDopen_m] = React.useState(false);
  const [dopen_ref, setDopen_ref]= React.useState(true);
  const [Loading, setLoading] = React.useState(false);

  var cart_amount = 0.0
    
  const dhandleClickOpen = () => {
    if (total_price>0) {
      sessionStorage.setItem('payment_type', 'creditcard' );
      var payment_type=sessionStorage.getItem('payment_type')  
      var subtotal_price = 0;
  var gateway_credit_card = 0;

  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    subtotal_price = subtotal_price + data.interest_payable ;
  }
  sessionStorage.setItem('QR_price_int', subtotal_price.toFixed(2) );
  
  var subtotal_price = 0;
  
  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    subtotal_price = subtotal_price + data.interest_payable ;
  }
  

  
  var admin_price = 0;
  
  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    admin_price = admin_price + 2.0;
  }
       
  

  gateway_credit_card =  0
    subtotal_price = subtotal_price + 0;

  if (payment_type==='creditcard')
      {  
  
          
          cart_amount = subtotal_price  + admin_price;

          gateway_credit_card =  (cart_amount + 0.50) /  0.972  ;
          gateway_credit_card =  gateway_credit_card - cart_amount;
          
          const rounded = Number(gateway_credit_card.toFixed(2)); // Output: 3.14  
          gateway_credit_card = rounded
      }
    
  


    

  var gateway_total = 0 ;
  
  gateway_total = gateway_credit_card + admin_price ;
  subtotal_price = subtotal_price + gateway_total;    
  
  sessionStorage.setItem('gateway_credit_card', gateway_credit_card.toFixed(2) );
  sessionStorage.setItem('admin_price', admin_price.toFixed(2) );
  sessionStorage.setItem('QR_price', subtotal_price.toFixed(2));
  sessionStorage.setItem('gateway_total', gateway_total.toFixed(2) );
  sessionStorage.setItem('payment_type', 'creditcard' );
      
  var payment_type=sessionStorage.getItem('payment_type')  
  var payment = ""
  if (payment_type==='creditcard') {payment = "CREDIT CARD"}
  if (payment_type==='pawnow') {payment = "PAYNOW"}

  toast.success("match1-ticketmodal-"+payment) 
  
      setDopen(true);
    } else {
    
    }
  };




  const dhandleClickOpen_hit = () => {
    if (total_price>0) {
      sessionStorage.setItem('payment_type', 'paynow' );
      var payment_type=sessionStorage.getItem('payment_type')  
  
      var subtotal_price = 0;
  var gateway_credit_card = 0;

  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    subtotal_price = subtotal_price + data.interest_payable ;
  }
  sessionStorage.setItem('QR_price_int', subtotal_price.toFixed(2) );
  

  
  var subtotal_price = 0;
  
  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    subtotal_price = subtotal_price + data.interest_payable ;
  }
  
  var admin_price = 0;
  
  for (let i = 0; i < props.data.length; i++) {
    let data = props.data[i];
    admin_price = admin_price + 2.0;
  }
  cart_amount = subtotal_price  + admin_price;
         
  if (payment_type==='paynow')
    {  

        if (cart_amount>=100)
          {
          gateway_credit_card =  (cart_amount + 0.30) /  0.9935  ;
          gateway_credit_card =  gateway_credit_card - cart_amount;

          }
          else
          {
          gateway_credit_card =  (cart_amount ) /  0.991; 
          gateway_credit_card =  gateway_credit_card - cart_amount;

          }
                
        
      
        var rounded = Number(gateway_credit_card.toFixed(2)); // Output: 3.14  

        if (rounded<=0.2) {rounded=0.2;}
        
        gateway_credit_card = rounded
    }
  


  var payment_type=sessionStorage.getItem('payment_type')  

    
  var payment = ""
  if (payment_type==='creditcard') {payment = "CREDIT CARD"}
  if (payment_type==='pawnow') {payment = "PAYNOW"}

  


    

  var gateway_total = 0 ;
  
  gateway_total = gateway_credit_card + admin_price ;
  subtotal_price = subtotal_price + gateway_total;    
  
  sessionStorage.setItem('gateway_credit_card', gateway_credit_card.toFixed(2) );
  sessionStorage.setItem('admin_price', admin_price.toFixed(2) );
  sessionStorage.setItem('QR_price', subtotal_price.toFixed(2) );
  sessionStorage.setItem('gateway_total', gateway_total.toFixed(2) );
  toast.success("match-ticketmodal-paynow-"+payment_type) 

      setDopen(true);
    } else {
    
    }
  };

  const dhandleClose = (value) => {
    setDopen(false);
  };

  const dhandleOPen = (value) => {
    
  };

  const dhandleClickOpen_m = () => {
    if (total_price>0) {
      setDopen_m(true);
    } else {
    
    }
  };

  const dhandleClose_m = (value) => {
    setDopen_m(false);
  };

  var total_price = 0

  for (let i = 0; i < props.data.length ; i++) {
    let data = props.data[i];
    total_price = total_price + parseInt(data.interest_payable)
  }


  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {




    
    encryptedStr = localStorage.getItem('data.orderIDInLocalStorage')
    



    if (dopen_ref)
    {

 

    setDopen_ref(false);
    props.data.orderID = encryptedStr

    


    

    }

    
  });

  var shopname = sessionStorage.getItem('shop')  
  var isactive

  if (shopname ==='Sembawang Teck Hing')
  {
  isactive = true
  }
  if (shopname === 'Sheng Cheong Pawnshop'  )
  {
  isactive = true
  }
  if (shopname === 'Trustcare Shop A'  )
  {
    isactive = true
  }
  if (shopname === 'Trustcare'  )
  {
    isactive = true
  }

  const defaultTheme = createMuiTheme({
    overrides: {
      MuiButton:{
       root: {
       // Some CSS
        minWidth : '10px',
        maxWidth : '100px',
  
       },    
      },
  
    },
  
  });
  
  
  return (
    <div>

    <Grid
      container 
    >
      <Grid item>


      
{<Grid container spacing={2} justify='space-between'>


   {/* 
   
   <Button type="submit" width="150" variant="contained" color="secondary" className={classes.submit} onClick={dhandleClickOpen_hit}>
      Paynow
      </Button>

      
  
        <Grid item xl={6} lg={6} md={8} sm={22} xs={22}>
      <ImageButton  color="white" type="submit" fullWidth className={classes.submit} onClick={dhandleClickOpen_hit}>
      <img src={myImage} alt="icon"  height = "40"  /> </ImageButton>
      </Grid>
  
      <Grid item xl={6} lg={6} md={8} sm={22} xs={22}>
      <ImageButton  color="white" type="submit" fullWidth className={classes.submit} onClick={dhandleClickOpen_hit}>
      <img src={myImage2} alt="icon" height = "40"    /> </ImageButton>
      </Grid>
   
*/}      
   
   <defaultTheme>
      
   
      
   <Box m={3} pt={3}>
   <RedButton   sx={{ flex: 1 }}  type="submit"  variant="contained" color="orange" className={classes.submit} onClick={dhandleClickOpen_hit}>
      Paynow</RedButton>
      </Box>
      
      
<Box m={2} pt={3}>
      <RedButton  sx={{ flex: 1 }}    type="submit"  variant="contained" color="orange" className={classes.submit} onClick={dhandleClickOpen}>
      Credit_Card</RedButton>
      </Box>

      </defaultTheme> 


      </Grid>


  
      
 
}

   
<SimpleDialog  open={dopen} onClose={dhandleClose}  data={props.data} />
     

    <div>
    <p> </p>
    </div>

 
  
     
      
  
      <div>
      <p> 
      </p>
      </div>

 
 
   
      <div>
<p> 
</p>
</div>

      </Grid>
    </Grid>
    </div>
  );
}
